import React from "react";
import Info from "components/chrome/main_view/info";
import SupportChat from "components/chrome/main_view/support_chat";
type PermissionMissingInfoProps = {
  pageName: string;
};

export default function PermissionMissingInfo({
  pageName,
}: PermissionMissingInfoProps) {
  return (
    <Info title={`Additional permissions required to view ${pageName}.`}>
      <p>Speak with your manager to extend your permissions.</p>
      <p>Our support team is here 24/7/365 to help.</p>
      <p>
        For assistance chat with us at <SupportChat />.
      </p>
    </Info>
  );
}
